import { get, post, put, del } from './http';

export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  phone?: string;
  subject?: string;
  type: string;
  message: string;
  submittedAt: string;
  read: boolean;
  starred: boolean;
  status: 'pending' | 'processing' | 'resolved' | 'ignored';
}

export function submitContactMessage(payload: {
  name: string;
  email: string;
  phone?: string;
  type: string;
  message: string;
}) {
  return post<{ message: string }>('/contact-messages', payload);
}

export function getContactMessages() {
  return get<ContactMessage[]>('/admin/contact-messages');
}

export function markContactMessageRead(id: string) {
  return put<{ message: string }>(`/admin/contact-messages/${id}/read`);
}

export function toggleContactMessageStar(id: string) {
  return put<{ message: string; starred: boolean }>(`/admin/contact-messages/${id}/star`);
}

export function deleteContactMessage(id: string) {
  return del<{ message: string }>(`/admin/contact-messages/${id}`);
}

export function markAllContactMessagesRead() {
  return post<{ message: string }>('/admin/contact-messages/read-all');
}

export function updateContactMessageStatus(id: string, status: string) {
  return put<{ message: string; status: 'pending' | 'processing' | 'resolved' | 'ignored' }>(`/admin/contact-messages/${id}/status`, { status });
}
